module.exports = __webpack_public_path__ + "img/add-user.50aff143.svg";